import React from 'react'
import Banner from '../components/Banner'
import '../style.css'
import { LinkWrap } from '@truphone/gatsby-wrappers'

function SupportMain(props) {
  return (
    <>
      <div
        className={`${
          props.dark ? 'bg-gradient-support text-white' : 'bg-white text-black'
        } bg-gradient-to-r pt-24`}
      ></div>
      <section className="bg-grey-100 py-10">
        <div className="container mx-auto px-2 md:px-6">
          <div className="flex justify-center flex-wrap">
            {props.blocks &&
              props.blocks.map((block, i) => {
                return (
                  <LinkWrap
                    href={block.href}
                    className="w-full sm:w-1/2 lg:w-1/4 p-3"
                    key={`products-block-${i}`}
                  >
                    <div className="bg-white p-4 sm:p-8 text-center w-full h-full rounded-sm shadow-sm hover:shadow-md">
                      <img className="h-15 mx-auto mb-4" src={block.icon} alt="" />
                      <h3 className="text-lg whitespace-nowrap xl:text-2xl">{block.title}</h3>
                    </div>
                  </LinkWrap>
                )
              })}
          </div>
        </div>
      </section>
      <Banner banner={props.banner} />
    </>
  )
}

export default SupportMain
